import React from "react";

import { Chip } from "@mui/material";
import clsx from "clsx";
import { CircleFlag } from "react-circle-flags";
import mainStyles from "styles";

import { regionValuesArr as ALL_REGION_CODES } from "api/index";

interface RegionChipProps {
  regionCode: string;
}

const RegionChip = ({ regionCode }: RegionChipProps) => {
  const classes = mainStyles();

  // Check if region code is valid (case insensitive)
  if (
    ALL_REGION_CODES.filter(
      (code) => code.toLowerCase() === regionCode.toLowerCase()
    ).length === 0
  ) {
    regionCode = "N/A";
  }

  return (
    <Chip
      size="small"
      color="default"
      className={clsx(classes.spaceRightXSmall)}
      style={{ fontWeight: "bold", marginBottom: "3px" }}
      label={regionCode.toUpperCase()}
      icon={
        regionCode === "N/A" ? (
          <CircleFlag countryCode="N/A" width="18px" /> // renders a question mark
        ) : (
          <CircleFlag countryCode={regionCode.toLowerCase()} width="18px" />
        )
      }
      data-testid="region-chip"
    />
  );
};

export default RegionChip;
